// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { TextAreaProps } from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setReturnEmail from "@store/Framework/Store/Pages/RequestRma/Handlers/SetRmaEmail";
import { RmaFormContext } from "@store/Library/Widgets/RequestRma/RequestRmaForm";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    emailAddress: state.store.pages.requestRma.email,
});

const mapDispatchToProps = {
    setReturnEmail,
};

export interface RequestRmaNotesStyles {
    wrapper?: InjectableCss;
}

export const notesStyles: RequestRmaNotesStyles = {
    wrapper: {
        css: css`
            padding-bottom: 20px;
        `,
    },
};

const styles = notesStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaStoreEmail: FC<Props> = ({ emailAddress, setReturnEmail }) => {
    const [emailAddressErrorMessage, setEmailAddressErrorMessage] = React.useState("");
    const rmaFormContext = useContext(RmaFormContext);

    const { value: order } = useContext(OrderStateContext);

    const validateEmailAddress = () => {
        let emailErrorMessage: ReturnType<typeof siteMessage> = "";
        if (!emailAddress) {
            emailErrorMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
        } else if (!validateEmail(emailAddress)) {
            emailErrorMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
        }
        setEmailAddressErrorMessage(emailErrorMessage.toString());
        return !emailErrorMessage!;
    };

    const emailAddressChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReturnEmail({ email: event.currentTarget.value });
    };

    React.useEffect(() => {
        rmaFormContext.validators.emailAddress = validateEmailAddress;
    }, [emailAddress]);

    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <TextField
                label={translate("Email")}
                required
                value={emailAddress}
                onChange={emailAddressChangeHandler}
                error={emailAddressErrorMessage}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaStoreEmail),
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        displayName: "Store Email Address",
        fieldDefinitions: [],
    },
};

export default widgetModule;
